var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number > 0)?_c('div',{staticClass:"tile",style:(_vm.style)},[_vm._v("\n  "+_vm._s(Math.pow(2,_vm.number)*(.5*_vm.pieceVal))+"\n")]):_c('div',{staticClass:"tile"},[_vm._v("\n  0\n")])}
var staticRenderFns = []

export { render, staticRenderFns }